import Api from './api';

const PesquisaService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/pesquisa/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletar: (id) => {
        Api.delete(`/restrito/pesquisa/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    medias: () => {
        const response = Api.get('/restrito/pesquisa/mediasorgao',
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    }
}

export default PesquisaService;